// extracted by mini-css-extract-plugin
module.exports = {"flex":"index_flex__eE8dJ","colBox":"index_colBox__fK4I_"};